import QuestionLayout from "./QuestionLayout";

const SHARPS_COUNT = 7;

const GLYPHS = {
  b: "♭",
  "#": "♯",
  flat: "♭",
  sharp: "♯"
};

export default function SharpsOrderInput({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  function setValue(index, v) {
    onChange({
      ...value,
      [index]: v.toUpperCase()
    });
  }

  function getInputStyle(i) {
    if (mode !== "review") {
      return { border: "1px solid #aaa" };
    }

    const part = feedback?.parts?.[i];
    if (!part) return { border: "1px solid #aaa" };

    return {
      border: `2px solid ${part.correct ? "#2e7d32" : "#c62828"}`
    };
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "14px",
          marginTop: "12px"
        }}
      >
        {Array.from({ length: SHARPS_COUNT }).map((_, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "4px"
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px"
              }}
            >
              {/* NOTE LETTER INPUT */}
              <input
                type="text"
                maxLength={1}
                value={value[i] || ""}
                disabled={mode !== "edit"}
                onChange={(e) => setValue(i, e.target.value)}
                style={{
                  width: "36px",
                  height: "36px",
                  textAlign: "center",
                  fontSize: "18px",
                  borderRadius: "4px",
                  textTransform: "uppercase",
                  ...getInputStyle(i)
                }}
              />

              {/* ACCIDENTAL DISPLAY (GLYPH ONLY) */}
              <span
                style={{
                  fontSize: "26px",
                  lineHeight: "1",
                  userSelect: "none"
                }}
              >
                {GLYPHS[config.sign] ?? config.sign}
              </span>
            </div>
          </div>
        ))}
      </div>
    </QuestionLayout>
  );
}
